/**
 * Validate link
 *
 * @param {String} link
 *
 * @return {boolean}
 */
export function isLinkValidation(link) {
    if (!link) {
        return null;
    }

    link = link.trim();
    const position = link.indexOf('.');

    return position === -1 || position === link.length - 1 || position === 0 ? 'validation.error.invalid_link' : null;
}



// WEBPACK FOOTER //
// ./src/utils/isLinkValidation.js